module.exports = "\n\t<slot>\n\t</slot>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./source/scripts/components/hidden-element.vue
// module id = 235
// module chunks = 16